import { render, staticRenderFns } from "./WebcamVideo.vue?vue&type=template&id=60ff29de&scoped=true"
import script from "./WebcamVideo.vue?vue&type=script&lang=js"
export * from "./WebcamVideo.vue?vue&type=script&lang=js"
import style0 from "./WebcamVideo.vue?vue&type=style&index=0&id=60ff29de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff29de",
  null
  
)

export default component.exports